<template>
  <div
    class="item d-flex flex-column"
    :class="{
      'cursor-pointer': !hasNotes && canEdit,
      'item-has-notes': hasNotes
    }"
    @click="emitAddDialog"
  >
    <div
      class="flex"
      :class="{ 'cursor-pointer': canEdit }"
      @click="showDialogAddNote"
    >
      <div class="flex-inner">
        <ib-tooltip
          effect="dark"
          placement="bottom"
          popper-class="plan-popper"
        >
          <div
            slot="content"
            class="tooltip-content"
          >
            <p
              class="tooltip-title"
              v-text="`${$t(`pages.ideaPlan.sections.${data.title}`)}`"
            />
            <div v-html="$t(`pages.ideaPlan.sectionsDescription.${data.title}`)" />
          </div>

          <img
            :src="baseUrl + data.icon"
            :alt="data.title"
          >
        </ib-tooltip>

        <h4
          :class="{
            'item-title': !hasNotes,
            'item-has-notes-title': hasNotes
          }"
          v-text="`${$t(`pages.ideaPlan.sections.${data.title}`)}`"
        />
      </div>

      <el-button
        v-if="canEdit"
        class="item-add-note-button d-md-none d-xl-block"
        type="plus-round-xs"
        icon="el-icon-plus"
        @click="showDialogAddNote"
      />
    </div>

    <template v-if="hasNotes">

      <ib-draggable
        class="flex-grow-1"
        :list="data.notes"
        :options="{disabled: !canEdit}"
        group="notes"
        draggable=".note"
        @change="onChangeOrder"
      >
        <div
          v-for="note in data.notes"
          :key="note.id"
          class="note"
          :class="note.color + [canEdit ? ' cursor-move' : '']"
          @click="showDialogEditNote(note)"
        >

          <h4 v-text="whiteSpace(note.title)" />
          <div v-html="note.text" />

          <div v-if="canEdit" class="edit-bottom">
            <a @click="showDialogEditNote(note)">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" v-bind:svg-inline="''" :style="{ width: '20px', height: '20px' }" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M21.809 0a.608.608 0 00-.432.18L20.154 1.4 22.6 3.846l1.22-1.223a.61.61 0 000-.863L22.24.18A.608.608 0 0021.81 0zm-2.52 2.266L12 9.556V12h2.443l7.291-7.291-2.445-2.443zM5 3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-9a1 1 0 00-2 0l-.002 9H5V7h6.729l4-4H5z"/></svg>
            </a>
            <a @click.stop="showDialogRemoveNote(note)">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" v-bind:svg-inline="''" :style="{ width: '20px', height: '20px' }" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10 2L9 3H5c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1h-4l-1-1h-4zM5 7v13c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7H5zm4 2c.6 0 1 .4 1 1v9c0 .6-.4 1-1 1s-1-.4-1-1v-9c0-.6.4-1 1-1zm6 0c.6 0 1 .4 1 1v9c0 .6-.4 1-1 1s-1-.4-1-1v-9c0-.6.4-1 1-1z"/></svg>
            </a>
          </div>

        </div>
      </ib-draggable>

    </template>

    <template v-else>
      <ib-draggable
        class="flex-grow-1"
        group="notes"
        :list="data.notes"
        @change="onChangeOrder"
      >
        <div
          class="placeholder-text"
          @click="showDialogAddNote"
          v-html="$t(`pages.ideaPlan.sectionsDescription.${data.title}`)"
        />
      </ib-draggable>
    </template>

    <el-button
      v-if="canEdit"
      class="item-add-note-button-bottom d-md-block d-xl-none"
      type="plus-round-xs"
      icon="el-icon-plus"
      @click="showDialogAddNote"
    />

  </div>
</template>

<script>
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import { mapActions } from 'vuex'

export default {
  name: 'SectionItem',

  mixins: [
    MixinIdeaRoles
  ],

  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL
    }
  },

  computed: {
    hasNotes () {
      return (this.data.notes && this.data.notes.length > 0)
    }
  },

  methods: {
    ...mapActions('idea', [
      'updateOrderNumber'
    ]),

    whiteSpace (a) {
      return a.replace(/^\s+|\s+$/gm, '')
    },

    emitAddDialog () {
      if (!this.hasNotes) {
        this.showDialogAddNote()
      }
    },

    showDialogAddNote () {
      this.$emit('dialog-add-show', this.data)
    },

    showDialogEditNote (note) {
      this.$emit('dialog-edit-note', this.data, note)
    },

    showDialogRemoveNote (note) {
      this.$emit('dialog-remove-note', note)
    },

    onChangeOrder (data) {
      this.updateOrderNumber({
        type: 'ideaPlan',
        data,
        oldOrderData: data.notes,
        mutation: 'ideaPlan/updateSection',
        additional: this.data.id
      })
    }
  }
}
</script>
<style scoped lang="scss">
.item {
  background-color: $color-white;
  transition: all 0.25s;
}

.item:hover,
.item-has-notes:hover
{
  background-color: $color-blue-hover;
}

.item-title,
.placeholder-text >>> p {
  color: $color-navy;
}

</style>
